<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="type">{{ 'TYPES.TYPES_FORM.EDIT' | translate }}</span>
    <span *ngIf="!type">{{ 'TYPES.TYPES_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="type-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-8">
        <div class="form-group">
          <label>{{ 'TYPES.TYPES_FORM.TYPE' | translate }}</label>
          <ng-select [items]="data" [loading]="loader" formControlName="type"></ng-select>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label>{{ 'TYPES.TYPES_FORM.ICON' | translate }}</label>
          <input type="text" class="form-control" formControlName="icon" />
        </div>
      </div>

      <div class="col-sm-1">
        <div class="form-group">
          <label>{{ 'TYPES.TYPES_FORM.COLOR' | translate }}</label>
          <div>
            <!--            z-index-a е сетнат в theme.scss-->
            <input type="color" formControlName="color" class="color-picker-custom" />
          </div>
        </div>
      </div>

      <div class="col-sm-4" [ngClass]="type?.id ? 'col-sm-4' : 'col-sm-6'">
        <div class="form-group">
          <label>{{ 'TYPES.TYPES_FORM.VALUE' | translate }}</label>
          <input type="text" class="form-control" formControlName="value" />
        </div>
      </div>

      <div class="col-sm-4" [ngClass]="type?.id ? 'col-sm-4' : 'col-sm-5'">
        <div class="form-group">
          <label>{{ 'TYPES.TYPES_FORM.REAL_VALUE' | translate }}</label>
          <input type="text" class="form-control" formControlName="real_value" />
        </div>
      </div>

      <div class="col-sm-3" *ngIf="type?.id">
        <div class="form-group">
          <label>{{ 'TYPES.TYPES_FORM.ORDER_INDEX' | translate }}</label>
          <input type="text" class="form-control" formControlName="order_index" />
        </div>
      </div>
    </div>
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input" formControlName="active" />
      <label class="form-check-label">{{ 'TYPES.TYPES_FORM.ACTIVE' | translate }}</label>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="type-form" [disabled]="form.invalid">
    {{ 'TYPES.TYPES_FORM.SAVE' | translate }}
  </button>
</div>
